
export const ENSEIGNANT_MES_COURS_INITIATE_FETCH_RESSOURCE = 'ENSEIGNANT_MES_COURS_INITIATE_FETCH_RESSOURCE';
export const ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_START = 'ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_START';
export const ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_SUCCESS = 'ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_SUCCESS';
export const ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_FAIL = 'ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_FAIL';
export const ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_RESET = 'ENSEIGNANT_MES_COURS_FETCH_RESSOURCE_RESET';